export default __webpack_public_path__ + "static/media/clipboard.ab915468.svg";